// auth.js
import React, { createContext, useContext, useState } from 'react';
import StorageHelper from '../../../utils/storage-helper';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    StorageHelper.get('isAuthenticated') === true
  );
  const [user, setUser] = useState(null);

  const login = (user) => {
    StorageHelper.set('isAuthenticated', true);
    setIsAuthenticated(true);
    setUser(user);
  };

  const logout = () => {
    StorageHelper.clear();
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
